import {
    Autocomplete,
    TextField,
} from '@mui/material'
import { disableFieldCheck } from '../../services/validation/address-employment-form/disableFieldCheck'
import { Option } from "../../services/ntuc/userService/staticData"
import { SyntheticEvent, useEffect, useState } from 'react'
import { capitaliseText } from '../../helpers/StringHelpers'

export interface DropdownProps {
    title: string
    defaultValue: Option | undefined
    options: Option[]
    showError: boolean
    errorMessage: string
    onChange: (value: Option) => void
    onBlur: (value: string) => void
    dependentField?: string
}

export function DropDown(props: DropdownProps) {
    const {
        title,
        defaultValue,
        options,
        showError,
        errorMessage,
        onChange,
        onBlur,
        dependentField,
    } = props
    const id = `${title}-dropdown`

    const [value, setValue] = useState(defaultValue)
    const [inputValue, setInputValue] = useState(``)

    const handleChange = (event: React.SyntheticEvent<Element, Event>, newValue: Option | null) => {
        onChange(newValue || { code: ``, value: ``})
        setValue(newValue || { code: ``, value: ``})
    }

    const handleInputOnChange = (event: SyntheticEvent<Element, Event>, newValue: string) => {
        setInputValue(capitaliseText(newValue))
    }

    const handleOnBlur = (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement, Element>) => {
        onBlur(event.target.value)
    }

    const handleGetOptionLabel = (option: Option) => option.value

    const handleOptionEqualToValue = (option: Option, value: Option) => {
        return option.code == value.code
    }

    const checkDisabled = () => {
        if (disableFieldCheck.has(dependentField ?? ``)) {
            return true
        }
        return false
    }

    useEffect(() => {
        if (defaultValue !== null && defaultValue !== undefined) {
            setValue(defaultValue)
        }
    }, [defaultValue])

    return (
        <Autocomplete
            disablePortal
            id={id}
            options={options}
            value={value}
            inputValue={inputValue}
            onInputChange={handleInputOnChange}
            onChange={handleChange}
            getOptionLabel={handleGetOptionLabel}
            isOptionEqualToValue={handleOptionEqualToValue}
            renderInput={(params) => (
                <TextField
                    error={showError}
                    helperText={errorMessage}
                    {...params}
                    label={title}
                    onBlur={handleOnBlur}
                />
            )}
            hidden={checkDisabled()}
        />
    )
}